/* GF search — predictive search for gymflooringuk.uk
   Markup: snippets/gf-search.liquid (+ gf-search-zero.liquid). Styles: gf-search.css */
(function () {
  'use strict';
  if (window.GFSearchInit) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 160;
  var RECENT_KEY = 'gfs_recent_v1';
  var HINTS = ['20mm rubber tiles', 'garage gym flooring', 'acoustic tiles', 'rubber roll', 'EVA foam tiles', 'deadlift'];
  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

  // Shortcut rows shown above results when the query signals a non-product intent.
  var INTENTS = [
    { re: /sampl/i, label: 'Get free samples', sub: 'Feel the thickness before you order', url: '/pages/free-sample' },
    { re: /trade|bulk|quote|wholesale|contractor|school|council/i, label: 'Trade & bulk pricing', sub: 'Quotes for gyms, schools and contractors', url: '/pages/trade-commercial-enquiries' },
    { re: /financ|klarna|pay ?later|monthly|instal/i, label: 'Spread the cost', sub: 'Gym flooring finance options', url: '/pages/gym-flooring-finance' },
    { re: /deliver|shipping|postage|dispatch|return|refund/i, label: 'Delivery & returns', sub: 'Free UK delivery, 14-day returns', url: '/pages/faq' },
    { re: /contact|phone|call|expert|advice|help|install|fitting/i, label: 'Talk to a flooring expert', sub: 'Call 01282 277 710', url: 'tel:01282277710' }
  ];

  var recent = {
    get: function () {
      try { var v = JSON.parse(localStorage.getItem(RECENT_KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    },
    add: function (q) {
      q = (q || '').trim();
      if (q.length < MIN_CHARS) return;
      var list = recent.get().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
    },
    clear: function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} }
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Wrap query tokens in <mark>; matching runs on raw text so entities are never split.
  function hl(text, q) {
    var toks = (q || '').trim().split(/\s+/).filter(function (t) { return t.length > 1; })
      .map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!toks.length) return esc(text);
    return String(text).split(new RegExp('(' + toks.join('|') + ')', 'ig')).map(function (part, i) {
      return i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part);
    }).join('');
  }

  // "20mm Tiles | 400kg Rated | Gym Flooring UK" -> name + short spec line
  function splitTitle(title) {
    var parts = String(title || '').split(/\s+\|\s+/);
    var spec = parts.slice(1).filter(function (p) { return !/gym ?flooring ?uk/i.test(p); }).slice(0, 2).join(' · ');
    return { name: parts[0], spec: spec };
  }

  function sized(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : gbp.format(n);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var uidCounter = 0;

  // Plain class on a <div data-gf-search>, not a custom element: the theme's <is-land>
  // wrappers rename undefined custom elements until hydration, which broke styling and init.
  class GFSearch {
    constructor(el) {
      this.el = el;
      el._gfs = this;
      this.context = el.dataset.context || 'header';
      this.form = el.querySelector('form');
      this.input = el.querySelector('.gfs__input');
      this.panel = el.querySelector('.gfs__panel');
      this.zero = el.querySelector('.gfs__zero');
      this.live = el.querySelector('.gfs__live');
      this.status = el.querySelector('[data-gfs-status]');
      this.clearBtn = el.querySelector('[data-gfs-clear]');
      this.cache = new Map();
      this.seq = 0;
      this.active = -1;
      this.uid = 'gfs' + (++uidCounter);
      this.lastQuery = '';
      this.debounced = null;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.clearBtn.addEventListener('click', this.onClear.bind(this));
      this.panel.addEventListener('click', this.onPanelClick.bind(this));
      this.panel.addEventListener('mousemove', this.onPanelHover.bind(this));

      if (this.context !== 'mobile') {
        this._outside = function (e) { if (!this.el.contains(e.target)) this.close(); }.bind(this);
        document.addEventListener('pointerdown', this._outside);
        this.el.addEventListener('focusout', function (e) {
          if (e.relatedTarget && !this.el.contains(e.relatedTarget)) this.close();
        }.bind(this));
      }

      if (this.context === 'header') {
        document.addEventListener('keydown', function (e) {
          if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
          var t = e.target;
          if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
          if (!this.el.offsetParent) return; // hidden (mobile layout)
          e.preventDefault();
          this.input.focus();
        }.bind(this));
      }

      this.startHints();
      this.renderRecent();
    }

    /* ---------- placeholder hints ---------- */
    startHints() {
      if (reducedMotion() || this.context === 'page') return;
      var i = 0, input = this.input;
      this._hintTimer = setInterval(function () {
        if (document.activeElement === input || input.value) return;
        input.placeholder = 'Try “' + HINTS[i++ % HINTS.length] + '”';
      }, 3200);
    }

    /* ---------- open / close ---------- */
    open() {
      if (this.context === 'mobile') return;
      if (!this.panel.hidden) return;
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.el.classList.add('is-open');
      this.fitPanel();
    }

    close() {
      if (this.context === 'mobile') return;
      if (this.panel.hidden) return;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.el.classList.remove('is-open');
      this.setActive(-1);
    }

    // Keep the dropdown inside the viewport when the field sits near the right edge.
    fitPanel() {
      this.panel.style.left = '';
      this.panel.style.right = '';
      if (window.innerWidth < 769) return;
      var r = this.panel.getBoundingClientRect();
      var over = r.right - (window.innerWidth - 16);
      if (over > 0) this.panel.style.left = (-over) + 'px';
    }

    /* ---------- events ---------- */
    onFocus() {
      this.renderRecent();
      var q = this.input.value.trim();
      if (q.length >= MIN_CHARS) this.search(q);
      else this.showZero();
      this.open();
    }

    onInput() {
      var q = this.input.value.trim();
      this.clearBtn.hidden = !this.input.value;
      clearTimeout(this.debounced);
      if (q.length < MIN_CHARS) {
        this.seq++;
        this.el.classList.remove('is-loading');
        this.showZero();
        this.open();
        return;
      }
      this.debounced = setTimeout(this.search.bind(this, q), this.cache.has(q.toLowerCase()) ? 0 : DEBOUNCE_MS);
    }

    onClear() {
      this.input.value = '';
      this.clearBtn.hidden = true;
      this.seq++;
      this.el.classList.remove('is-loading');
      this.showZero();
      this.open();
      this.input.focus();
    }

    onSubmit(e) {
      var q = this.input.value.trim();
      if (!q) { e.preventDefault(); this.input.focus(); return; }
      var opt = this.options()[this.active];
      if (opt && opt.href) { e.preventDefault(); this.follow(opt); return; }
      recent.add(q);
    }

    onKeydown(e) {
      var opts = this.options();
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (this.panel.hidden) { this.onFocus(); return; }
          this.setActive(opts.length ? (this.active + 1) % opts.length : -1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.setActive(opts.length ? (this.active <= 0 ? opts.length - 1 : this.active - 1) : -1);
          break;
        case 'Escape':
          if (this.context === 'mobile') { window.GFSearchOverlay && window.GFSearchOverlay.close(); return; }
          if (this.input.value && this.panel.hidden) { this.onClear(); return; }
          this.close();
          break;
        case 'Tab':
          this.close();
          break;
      }
    }

    onPanelClick(e) {
      if (e.target.closest('[data-gfs-clear-recent]')) {
        e.preventDefault();
        recent.clear();
        this.renderRecent();
        this.input.focus();
        return;
      }
      if (e.target.closest('[data-gfs-submit]')) {
        e.preventDefault();
        this.setActive(-1);
        this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
        return;
      }
      var chip = e.target.closest('[data-gfs-query]');
      if (chip) {
        e.preventDefault();
        this.input.value = chip.getAttribute('data-gfs-query');
        this.clearBtn.hidden = false;
        this.input.focus();
        this.search(this.input.value.trim());
        return;
      }
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.classList.contains('gfs__row-link--query')) recent.add(link.textContent.trim());
      else if (this.input.value.trim()) recent.add(this.input.value.trim());
    }

    onPanelHover(e) {
      var opt = e.target.closest('[role="option"]');
      if (!opt) return;
      var i = this.options().indexOf(opt);
      if (i !== this.active) this.setActive(i, true);
    }

    follow(opt) {
      if (opt.hasAttribute('data-gfs-query')) { opt.click(); return; }
      if (opt.hasAttribute('data-gfs-submit')) { this.setActive(-1); this.form.submit(); return; }
      if (opt.classList.contains('gfs__row-link--query')) recent.add(opt.textContent.trim());
      else if (this.input.value.trim()) recent.add(this.input.value.trim());
      window.location.href = opt.href;
    }

    /* ---------- options / keyboard highlight ---------- */
    options() {
      var box = this.live.hidden ? this.zero : this.live;
      return Array.prototype.filter.call(box.querySelectorAll('[role="option"]'), function (el) {
        return el.offsetParent !== null;
      });
    }

    setActive(i, fromHover) {
      var opts = this.options();
      if (this.active > -1 && opts[this.active]) opts[this.active].classList.remove('is-active');
      this.active = i;
      var el = opts[i];
      if (el) {
        el.classList.add('is-active');
        if (!el.id) el.id = this.uid + '-opt-' + i;
        this.input.setAttribute('aria-activedescendant', el.id);
        if (!fromHover) el.scrollIntoView({ block: 'nearest' });
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    /* ---------- rendering ---------- */
    showZero() {
      this.live.hidden = true;
      this.live.innerHTML = '';
      this.zero.hidden = false;
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
    }

    renderRecent() {
      var box = this.el.querySelector('[data-gfs-recent]');
      if (!box) return;
      var list = recent.get();
      box.closest('.gfs__recent').hidden = !list.length;
      box.innerHTML = list.map(function (q, i) {
        return '<a class="gfs__chip gfs__chip--recent" role="option" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '" data-gfs-query="' + esc(q) + '">' +
          '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</a>';
      }).join('');
    }

    search(q) {
      var key = q.toLowerCase();
      this.lastQuery = q;
      if (this.cache.has(key)) { this.render(this.cache.get(key), q); return; }

      var seq = ++this.seq;
      this.el.classList.add('is-loading');
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,page,article' +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          this.cache.set(key, res);
          if (this.cache.size > 40) this.cache.delete(this.cache.keys().next().value);
          if (seq !== this.seq) return;
          this.el.classList.remove('is-loading');
          this.render(res, q);
        }.bind(this))
        .catch(function () {
          if (seq !== this.seq) return;
          this.el.classList.remove('is-loading');
          this.render({}, q);
        }.bind(this));
    }

    render(res, q) {
      if (q !== this.input.value.trim()) return; // stale
      var products = res.products || [];
      var collections = (res.collections || []).slice(0, 4);
      var queries = (res.queries || []).filter(function (x) { return x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
      var pages = (res.pages || []).concat(res.articles || []).slice(0, 3);
      var intents = INTENTS.filter(function (it) { return it.re.test(q); }).slice(0, 2);
      var maxProducts = this.context === 'mobile' ? 6 : 5;
      var html = '';

      var side = '';
      if (queries.length) {
        side += '<div class="gfs__group" role="group" aria-label="Suggested searches"><p class="gfs__label" aria-hidden="true">Suggestions</p><ul class="gfs__links">' +
          queries.map(function (x) {
            return '<li><a class="gfs__row-link gfs__row-link--query" role="option" href="' + ROOT + 'search?q=' + encodeURIComponent(x.text) + '&options%5Bprefix%5D=last">' +
              '<svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg><span>' + hl(x.text, q) + '</span></a></li>';
          }).join('') + '</ul></div>';
      }
      var isMobile = this.context === 'mobile' || window.innerWidth < 769;
      if (collections.length && !isMobile) {
        side += '<div class="gfs__group" role="group" aria-label="Categories"><p class="gfs__label" aria-hidden="true">Categories</p><ul class="gfs__links">' +
          collections.map(function (c) {
            return '<li><a class="gfs__row-link" role="option" href="' + esc(c.url) + '"><span>' + hl(splitTitle(c.title).name, q) + '</span>' +
              '<svg class="gfs__chev" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg></a></li>';
          }).join('') + '</ul></div>';
      }
      if (pages.length) {
        side += '<div class="gfs__group" role="group" aria-label="Guides and help"><p class="gfs__label" aria-hidden="true">Guides &amp; help</p><ul class="gfs__links">' +
          pages.map(function (p) {
            return '<li><a class="gfs__row-link" role="option" href="' + esc(p.url) + '"><span>' + hl(splitTitle(p.title).name, q) + '</span></a></li>';
          }).join('') + '</ul></div>';
      }

      var main = '';
      // On phones, matching categories sit above products as a compact chip row.
      if (collections.length && isMobile) {
        main += '<div class="gfs__group gfs__catchips" role="group" aria-label="Categories"><p class="gfs__label" aria-hidden="true">Categories</p><div class="gfs__chips">' +
          collections.map(function (c) {
            return '<a class="gfs__chip gfs__chip--cat" role="option" href="' + esc(c.url) + '">' + hl(splitTitle(c.title).name, q) + '</a>';
          }).join('') + '</div></div>';
      }
      if (intents.length) {
        main += '<ul class="gfs__intents">' + intents.map(function (it) {
          return '<li><a class="gfs__intent" role="option" href="' + it.url + '"><span class="gfs__intent-t">' + esc(it.label) + '</span><span class="gfs__intent-s">' + esc(it.sub) + '</span>' +
            '<svg class="gfs__chev" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg></a></li>';
        }).join('') + '</ul>';
      }
      if (products.length) {
        main += '<div class="gfs__group" role="group" aria-label="Products"><p class="gfs__label" aria-hidden="true">Products</p><ul class="gfs__products">' +
          products.slice(0, maxProducts).map(function (p) {
            var t = splitTitle(p.title);
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            var min = parseFloat(p.price_min || p.price), max = parseFloat(p.price_max || p.price);
            var cmp = parseFloat(p.compare_at_price_max || 0);
            var price = (max > min ? '<small>From</small> ' + money(min) : money(p.price)) +
              (cmp > max ? ' <s class="gfs__muted">' + money(cmp) + '</s>' : '');
            return '<li><a class="gfs__product" role="option" href="' + esc(p.url) + '">' +
              '<span class="gfs__thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" width="80" height="80" decoding="async">' : '') + '</span>' +
              '<span class="gfs__pinfo"><span class="gfs__pname">' + hl(t.name, q) + '</span>' +
              (t.spec ? '<span class="gfs__pspec">' + hl(t.spec, q) + '</span>' : '') +
              '<span class="gfs__pmeta"><span class="gfs__price">' + price + '</span>' +
              (p.available === false ? '<span class="gfs__oos">Out of stock</span>' : '<span class="gfs__stock">In stock</span>') +
              '</span></span></a></li>';
          }).join('') + '</ul></div>';
      }

      var total = products.length + collections.length + queries.length + pages.length;

      if (!total) {
        this.live.innerHTML =
          '<div class="gfs__empty"><p class="gfs__empty-t">No exact matches for “' + esc(q) + '”</p>' +
          '<p class="gfs__empty-s">Try a thickness (e.g. <button type="button" class="gfs__inline" data-gfs-query="20mm">20mm</button>), a product (<button type="button" class="gfs__inline" data-gfs-query="rubber tiles">rubber tiles</button>, <button type="button" class="gfs__inline" data-gfs-query="rubber roll">rolls</button>) or a space (<button type="button" class="gfs__inline" data-gfs-query="garage gym">garage gym</button>). Or ask our team.</p></div>' +
          (intents.length ? main : '') +
          '<div class="gfs__empty-zero"></div>';
        // Reuse the server-rendered categories + best sellers from the zero state.
        var zeroCols = this.zero.querySelector('.gfs__cols');
        if (zeroCols) {
          var clone = zeroCols.cloneNode(true);
          var rec = clone.querySelector('.gfs__recent');
          if (rec) rec.remove();
          clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
          clone.querySelectorAll('[aria-labelledby]').forEach(function (el) { el.removeAttribute('aria-labelledby'); });
          this.live.querySelector('.gfs__empty-zero').appendChild(clone);
        }
        this.announce('No results for ' + q);
      } else {
        html = '<div class="gfs__cols' + (side ? '' : ' gfs__cols--single') + '">' +
          (side ? '<div class="gfs__col gfs__col--side">' + side + '</div>' : '') +
          '<div class="gfs__col gfs__col--main">' + main + '</div></div>' +
          '<button type="submit" class="gfs__all" role="option" data-gfs-submit>See all results for “' + esc(q) + '”' +
          '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
        this.live.innerHTML = html;
        this.announce(products.length + ' products and ' + (total - products.length) + ' other suggestions');
      }

      this.zero.hidden = true;
      this.live.hidden = false;
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
      if (document.activeElement === this.input || this.context === 'mobile') this.open();
    }

    announce(msg) {
      if (!this.status) return;
      clearTimeout(this._announceT);
      this._announceT = setTimeout(function () { this.status.textContent = msg; }.bind(this), 400);
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-gf-search]').forEach(function (el) {
      if (!el._gfs) new GFSearch(el);
    });
  }
  window.GFSearchInit = init;

  /* ---------- mobile full-screen overlay ---------- */
  var Overlay = {
    el: null,
    lastFocus: null,
    pushed: false,
    init: function () {
      this.el = document.getElementById('gfsOverlay');
      if (!this.el) return;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-gfs-open]');
        if (opener) { e.preventDefault(); Overlay.open(opener); return; }
        if (e.target.closest('[data-gfs-close]')) { e.preventDefault(); Overlay.close(); }
      });
      window.addEventListener('popstate', function () {
        if (Overlay.pushed) { Overlay.pushed = false; Overlay.hide(); }
      });
    },
    open: function (opener) {
      if (!this.el || !this.el.hidden) return;
      this.lastFocus = opener || document.activeElement;
      // Close the mobile drawer if the search was opened from inside it.
      var drawer = document.getElementById('gymMobileDrawer');
      if (drawer && drawer.classList.contains('active')) {
        var closeBtn = document.getElementById('gymMobileClose');
        if (closeBtn) closeBtn.click();
      }
      this.el.hidden = false;
      document.documentElement.classList.add('gfs-lock');
      var input = this.el.querySelector('.gfs__input');
      // Focus synchronously inside the tap handler so iOS raises the keyboard.
      if (input) { input.focus(); var comp = input.closest('[data-gf-search]'); if (comp && comp._gfs) comp._gfs.renderRecent(); }
      try { history.pushState({ gfsOverlay: true }, ''); this.pushed = true; } catch (e) {}
    },
    hide: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      document.documentElement.classList.remove('gfs-lock');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },
    close: function () {
      if (this.pushed) { this.pushed = false; history.back(); }
      this.hide();
    }
  };
  window.GFSearchOverlay = Overlay;
  function boot() { init(); Overlay.init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();